<template>
  <div>
    <el-button type="success" @click="$modal.show('educational-dialog')">
      自動入力
    </el-button>

    <div class="education-option">
      <modal
        name="educational-dialog"
        :adaptive="true"
        :scrollable="true"
        height="auto"
      >
        <div class="v--modal-close-top">
          <el-button
            @click="$modal.hide('educational-dialog')"
            icon="el-icon-close"
            type="text"
          ></el-button>
        </div>
        <div class="title">学歴自動入力</div>
        <p>生年月日と在籍年数を元に、入学・卒業年を自動計算します。</p>
        <p>※年は西暦で出力されます。</p>
        <p>&nbsp;</p>
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">生年月日</div>
            <div class="item-body flex align-items-center">
              <el-input
                class="input-xs"
                placeholder="2000"
                title="年"
                v-model="birthYear"
                min="1890"
                type="number"
              ></el-input
              ><span>年</span>
              <el-input
                class="input-xs input-2-digit"
                placeholder="00"
                title="月"
                v-model="birthMonth"
                min="1"
                max="12"
                type="number"
              ></el-input
              ><span>月</span>
              <el-input
                class="input-xs input-2-digit"
                placeholder="00"
                title="日"
                v-model="birthDay"
                min="1"
                max="31"
                type="number"
              ></el-input
              ><span>日</span>
            </div>
            <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
            <div class="item-name">最後の学歴</div>
            <div class="item-body">
              <el-select
                v-model="options.lastEducationalBackground"
                placeholder="Select"
              >
                <el-option
                  v-for="item in lastEducationalBackgroundOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="edu-auto-school">
            <div class="edit-form-item">
              <div class="item-name">
                中学校
                <el-checkbox
                  v-model="options.periods.juniorHighSchool.display"
                  class="edu-auto-checkbox"
                  >履歴書に記入する</el-checkbox
                >
              </div>
              <div class="item-body">
                <el-input
                  v-model="options.periods.juniorHighSchool.name"
                  v-show="options.periods.juniorHighSchool.display"
                  class="school-name"
                  :placeholder="
                    options.periods.juniorHighSchool.display
                      ? options.periods.juniorHighSchool.defaultName
                      : '記入されません'
                  "
                ></el-input>
                <el-input
                  v-model="options.periods.juniorHighSchool.period"
                  class="period input-2-digit"
                  controls-position="right"
                  type="number"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">
                <div
                  v-if="
                    options.lastEducationalBackground ===
                    'instituteOfTechnologyCollege'
                  "
                >
                  高等専門学校(高専)
                </div>
                <div v-else>
                  高等学校
                  <el-checkbox
                    v-model="options.periods.highSchool.display"
                    class="edu-auto-checkbox"
                    >履歴書に記入する</el-checkbox
                  >
                </div>
              </div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="
                    options.periods.highSchool.display
                      ? options.periods.highSchool.defaultName
                      : '記入されません'
                  "
                  v-model="options.periods.highSchool.name"
                  v-show="options.periods.highSchool.display"
                ></el-input>
                <el-input
                  v-model="options.periods.highSchool.period"
                  class="period input-2-digit"
                  type="number"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <span v-if="options.periods.highSchool.display">
                  <el-select
                    v-model="options.periods.highSchool.graduateLabel"
                    class="input-sm"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in graduateLabels"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </span>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                !(
                  options.lastEducationalBackground in
                  { highSchool: 1, instituteOfTechnologyCollege: 1 }
                )
              "
            >
              <div class="item-name">高校卒業後(予備校・浪人など)</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  disable
                  :placeholder="options.periods.afterHighSchool.defaultName"
                  v-model="options.periods.afterHighSchool.name"
                  v-show="false"
                ></el-input>
                <el-input
                  v-model="options.periods.afterHighSchool.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間</span>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                options.lastEducationalBackground in
                { university: 0, master: 0, docter: 0 }
              "
            >
              <div class="item-name">大学</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.university.defaultName"
                  v-model="options.periods.university.name"
                ></el-input>
                <el-input
                  v-model="options.periods.university.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.university.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground == 'juniorCollege'"
            >
              <div class="item-name">短期大学</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  v-model="options.periods.juniorCollege.name"
                  :placeholder="options.periods.juniorCollege.defaultName"
                  :disabled="
                    options.lastEducationalBackground != 'juniorCollege'
                  "
                ></el-input>
                <el-input
                  v-model="options.periods.juniorCollege.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.juniorCollege.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground == 'specialSchool'"
            >
              <div class="item-name">専門学校</div>
              <div class="item-body">
                <el-input
                  v-model="options.periods.specialSchool.name"
                  class="school-name"
                  :placeholder="options.periods.specialSchool.defaultName"
                  :disabled="
                    options.lastEducationalBackground != 'specialSchool'
                  "
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.specialSchool.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.specialSchool.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                options.lastEducationalBackground in { docter: 1, master: 1 }
              "
            >
              <div class="item-name">大学院（修士）</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.master.defaultName"
                  v-model="options.periods.master.name"
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.master.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.master.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground in { docter: 1 }"
            >
              <div class="item-name">大学院（博士）</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.docter.defaultName"
                  v-model="options.periods.docter.name"
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.docter.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.docter.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <el-button type="primary" @click="autoComplete"
            >この内容で追加</el-button
          >
          <el-button @click="$modal.hide('educational-dialog')"
            >閉じる</el-button
          >
          <div>※現在入力している学歴はすべて上書きされます</div>
        </div>
        <div class="text-right">
          <br />
          <br />
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import _ from '@/assets/lib/my-lodash'
export default {
  props: {
    year: {
      type: [Number, String]
    },
    month: {
      type: [Number, String]
    },
    day: {
      type: [Number, String]
    }
  },
  data: function () {
    return {
      birthYear: 1985,
      birthMonth: 1,
      birthDay: 1,
      errorMessage: '',
      resetDialogVisible: false,
      educationalBackground: {},
      graduateLabels: [
        {
          value: '卒業',
          label: '卒業'
        },
        {
          value: '在学中',
          label: '在学中'
        },
        {
          value: '卒業見込み',
          label: '卒業見込み'
        },
        {
          value: '修了',
          label: '修了'
        },
        {
          value: '中退',
          label: '中退'
        }
      ],
      lastEducationalBackgroundOptions: [
        {
          value: 'highSchool',
          label: '高校'
        },
        {
          value: 'instituteOfTechnologyCollege',
          label: '高専'
        },
        {
          value: 'specialSchool',
          label: '専門学校'
        },
        {
          value: 'juniorCollege',
          label: '短大'
        },
        {
          value: 'university',
          label: '大学'
        },
        {
          value: 'master',
          label: '大学院(修士)'
        },
        {
          value: 'docter',
          label: '大学院(博士)'
        }
      ],
      options: {
        lastEducationalBackground: 'university',
        periods: {
          // 中学
          juniorHighSchool: {
            name: '',
            display: false,
            defaultName: '〇〇市立〇〇中学校',
            period: 3,
            displayEnter: false
          },
          // 高校
          highSchool: {
            name: '',
            display: true,
            defaultName: '〇〇県立〇〇高等学校 普通科',
            period: 3,
            graduateLabel: '卒業'
          },
          afterHighSchool: {
            name: '',
            defaultName: '高校卒業後(記入されません)',
            period: 0
          },
          // 大学
          university: {
            name: '',
            defaultName: '〇〇大学 〇〇学部 〇〇学科',
            period: 4,
            graduateLabel: '卒業'
          },
          // 短大
          juniorCollege: {
            name: '',
            defaultName: '〇〇短期大学 〇〇学部 〇〇学科',
            period: 2,
            graduateLabel: '卒業'
          },
          // 専門
          specialSchool: {
            name: '',
            defaultName: '〇〇専門学校 ◯◯科 ◯◯コース',
            period: 2,
            graduateLabel: '卒業'
          },
          master: {
            name: '',
            defaultName: '◯◯大学 大学院　◯◯学研究科　◯◯学専攻　修士課程',
            period: 2,
            graduateLabel: '修了'
          },
          docter: {
            name: '',
            defaultName: '◯◯大学 大学院　◯◯学研究科　◯◯学専攻　博士課程',
            period: 2,
            graduateLabel: '修了'
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    autoComplete: function () {
      this.errorMessage = ''
      if (!this.birthYear || !this.birthMonth || !this.birthDay) {
        this.errorMessage = '生年月日を入力してください'
        return
      }
      this.createEducationalBackground(this.options)
      this.$emit(
        'create-educational-background',
        this.educationalBackground.getRirekishoList()
      )
      this.$modal.hide('educational-dialog')
    },
    createEducationalBackground: function () {
      const birthYear = Number(this.birthYear)
      const birthMonth = Number(this.birthMonth)
      const birthDay = Number(this.birthDay)
      const BackgroundItem = function (ItemOptions) {
        this.enable = ItemOptions.enable || false
        this.display = ItemOptions.display || false
        this.displayEnter = ItemOptions.hasOwnProperty('displayEnter')
          ? ItemOptions.displayEnter
          : true
        this.displayGraduate = ItemOptions.hasOwnProperty('displayGraduate')
          ? ItemOptions.displayGraduate
          : true
        this.period = Number(ItemOptions.period) || 0
        this.name = ItemOptions.name || ''
        this.enterMonth = ItemOptions.enterMonth || 4
        this.enterLabel = ItemOptions.enterLabel || '入学'
        this.graduateMonth = ItemOptions.graduateMonth || 3
        this.graduateLabel = ItemOptions.graduateLabel || '卒業'
        this.order = ItemOptions.order || 0
      }
      const educationalBackground = {}
      const getGraduateElementaryYear = () => {
        // 中学入学年度を計算（早生まれは１年遅れる）
        if (birthMonth < 4 || (birthMonth === 4 && birthDay === 1)) {
          return birthYear + 12
        } else {
          return birthYear + 13
        }
      }
      let order = 1
      const orderStep = 100
      educationalBackground.defaultOptions = {
        startYear: getGraduateElementaryYear(),
        lastEducationalBackground: 'university',
        higherEducations: [
          'specialSchool',
          'juniorCollege',
          'university',
          'master',
          'docter'
        ],
        periods: {
          // 中学
          juniorHighSchool: {
            enable: true,
            display: true,
            period: 3,
            name: '○○中学校',
            displayEnter: false,
            order: order++ * orderStep
          },
          afterJuniorHighSchool: {
            name: '高校浪人',
            order: order++ * orderStep
          },
          // 高校
          highSchool: {
            enable: true,
            display: true,
            period: 3,
            name: '○○高校',
            order: order++ * orderStep
          },
          afterHighSchool: {
            enable: true,
            name: '浪人',
            order: order++ * orderStep
          },
          // 短大
          juniorCollege: {
            display: true,
            period: 2,
            name: '○○短期大学',
            order: order++ * orderStep
          },
          // 専門
          specialSchool: {
            display: true,
            period: 2,
            name: '○○専門学校',
            order: order++ * orderStep
          },
          // 大学
          university: {
            display: true,
            period: 4,
            name: '私立〇〇大学 〇〇学部 〇〇学科',
            order: order++ * orderStep
          },
          master: {
            display: true,
            period: 2,
            name: '◯◯大学 大学院　◯◯学研究科　◯◯学専攻　修士課程',
            graduateLabel: '修了',
            order: order++ * orderStep
          },
          docter: {
            display: true,
            period: 2,
            name: '◯◯大学 大学院　◯◯学研究科　◯◯学専攻　博士課程',
            graduateLabel: '修了',
            order: order++ * orderStep
          }
        }
      }
      educationalBackground.options = _.defaultsDeep(
        this.options,
        educationalBackground.defaultOptions
      )
      educationalBackground.options.startYear = getGraduateElementaryYear()
      educationalBackground.setHigherEducationBackground = function (
        lastEducationalBackgroundKey
      ) {
        // console.log(lastEducationalBackgroundKey)
        // 指定した高等教育(lastEducationalBackground)のみ有効にする
        for (const key in this.options.higherEducations) {
          const he = this.options.higherEducations[key]
          if (!this.options.periods[he]) continue
          this.options.periods[he].enable = false
        }
        this.options.periods[lastEducationalBackgroundKey].enable = true

        if (lastEducationalBackgroundKey === 'master') {
          this.options.periods.university.enable = true
        }
        if (lastEducationalBackgroundKey === 'docter') {
          this.options.periods.university.enable = true
          this.options.periods.master.enable = true
        }
      }
      educationalBackground.getRirekishoList = function () {
        const options = this.options
        let lastEducationalBackground =
          options.lastEducationalBackground || 'university'
        // 高専は高校を上書きして使うため高校に戻す
        if (lastEducationalBackground === 'instituteOfTechnologyCollege') {
          lastEducationalBackground = 'highSchool'
        }
        this.setHigherEducationBackground(lastEducationalBackground)
        const rirekishoList = []
        let year = options.startYear
        const orderedPeriods = _.orderBy(options.periods, ['order'], ['asc'])
        for (const key in orderedPeriods) {
          const item = new BackgroundItem(orderedPeriods[key])
          if (!item.enable || !item.period === 0) {
            continue
          }
          if (item.display && item.displayEnter) {
            // console.log(item)
            rirekishoList.push({
              year,
              month: item.enterMonth,
              desc: item.name + ' ' + item.enterLabel
            })
          }
          year = year + item.period
          if (item.display && item.displayGraduate) {
            rirekishoList.push({
              year,
              month: item.graduateMonth,
              desc: item.name + ' ' + item.graduateLabel
            })
          }
          if (lastEducationalBackground === key) {
            break
          }
        }
        return rirekishoList
      }
      this.educationalBackground = educationalBackground
    }
  },
  watch: {
    year: function () {
      this.birthYear = this.year
    },
    month: function () {
      this.birthMonth = this.month
    },
    day: function () {
      this.birthDay = this.day
    },
    birthYear: function () {
      this.$eventHub.$emit('birth-year-changed', this.birthYear)
    },
    birthMonth: function () {
      this.$eventHub.$emit('birth-month-changed', this.birthMonth)
    },
    birthDay: function () {
      this.$eventHub.$emit('birth-day-changed', this.birthDay)
    },
    'options.lastEducationalBackground': function (newVal, oldVal) {
      if (newVal === 'instituteOfTechnologyCollege') {
        this.options.periods.highSchool.period = 5
        this.options.periods.highSchool.defaultName =
          '国立〇〇工業高等専門学校　〇〇科'
      } else {
        this.options.periods.highSchool.period = 3
        this.options.periods.highSchool.defaultName = '県立〇〇高等学校 普通科'
      }
    }
  },
  mounted: function () {
    this.birthYear = this.year
    this.birthMonth = this.month
    this.birthDay = this.day
  }
}
</script>
